module.exports = __webpack_public_path__ + "53ab3cf8ba311b8afdddd92ebc6a8a49.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/multigauge/multigauge.png
// module id = 791
// module chunks = 7